// extracted by mini-css-extract-plugin
export var waveContainer = "wave-module--wave-container--4n0qB";
export var waveSingle = "wave-module--wave-single--3hNol";